export default __webpack_public_path__ + "static/media/out to lunch.95845810.png";